import { render, staticRenderFns } from "./IndexColorsPage.vue?vue&type=template&id=70a46502&"
import script from "./IndexColorsPage.vue?vue&type=script&lang=js&"
export * from "./IndexColorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports